import { IconProps } from './index';

const PencilLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M3.345 12.333l8.452-8.451-1.179-1.179-8.451 8.452v1.178h1.178zM4.035 14H.5v-3.536L10.03.935a.833.833 0 011.178 0l2.357 2.358a.833.833 0 010 1.178L4.035 14zM.5 15.667h15v1.666H.5v-1.666z"
                fill="currentColor"
            />
        </svg>
    );
};

export default PencilLine;
